import { components } from '../../tokens/components/bluestone/OP';
import { createTheme } from '../../tokens/createTheme';
import type { DeprecatedTheme } from '../types';
import colorsOP from './colors/base/OP';
import alertTokens from './components/alert.tokens';
import createCalendarTokens from './components/calendar.tokens';
import checkboxTokens from './components/checkbox.tokens';
import drawerHeaderTokens from './components/drawerHeader.tokens';
import inputTokens from './components/input.tokens';
import pillTokens from './components/pill.tokens';
import sliderTokens from './components/slider.tokens';
import { ED } from './ED';

const colorsBrand = {
  0: '#FFE7D7', // brandPrimary.0 - primary.30
  1: '#FF6600', // brandPrimary.1 - primary.50
  2: '#E64E00', // brandPrimary.2 - primary.70
};
const brandSecondary = '#60BEBE';

const { colors: colorsED, borders, space, fontSizes, sizes, lineHeights } = ED;

const colors = {
  ...colorsED,
  ...colorsOP,
  brandPrimary: colorsBrand,
  promotional: {
    primary: {
      default: '#262626',
      dark: '#000000',
    },
    secondary: {
      default: colorsBrand[1],
      dark: '#6A3A1B',
    },
  },
};
const { neutrals: colorsGrey } = colors;
const fontSizeBody = fontSizes.body;

const drawerHeader = drawerHeaderTokens({
  colorsBrand,
  colors,
  borders,
  space,
});

const slider = sliderTokens({
  colors,
  colorsBrand,
  sizes,
  space,
  fontSizeBody,
});

const checkbox = checkboxTokens({
  borders,
  colors,
  colorsBrand,
  space,
  lineHeights,
  fontSizeBody,
});

const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});

const pill = pillTokens({ colors, colorsGrey });

const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const OP: DeprecatedTheme = createTheme(
  'blueStone',
  {
    ...ED,
    colors: {
      ...colors,
      text: colors,
      brandSecondary,
      slider: slider.colors,
      checkbox: checkbox.colors,
      brandedProgressBar: brandSecondary,
      drawerHeader: drawerHeader.colors,
      decorationLine: {
        ...ED.colors.decorationLine,
        default: brandSecondary,
      },
      input: input.colors,
      pill: pill.colors,
      alert: alert.colors,
      calendar: calendar.colors,
    },
    borders: {
      ...ED.borders,
      alert: alert.borders,
    },
  },
  components
);

export default OP;
